import { Injectable } from '@angular/core';
import { ClientPropertiesObject } from 'src/app/models/tasks/tasks-properties/client-properties/client-properties-object.model';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';

@Injectable({
    providedIn: 'root'
})
export class TaskClientPropertiesConverter implements Converter<ClientPropertiesObject>{

    public convert(input: any): ClientPropertiesObject {
        try {
            if (isNullOrUndefined(input)) return ClientPropertiesObject.create();

            return new ClientPropertiesObject(StringUtils.default(input.order.client.id), StringUtils.default(input.order.client.id),
                StringUtils.default(input.order.client.name));

        } catch (error) {
            console.error(error);
            return ClientPropertiesObject.create();
        }
    }

}
